module.exports = __webpack_public_path__ + "img/Collaborate.f6a27754.png";